import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { MdmFormProps } from "../../../Forms/MdmFormProps";
import { Edc } from "../../Edc";
import { useGoogleMapsModal } from "../../../GoogleMaps/useGoogleMapsModal";
import { OpenGoogleMapsIconButton } from "../../../GoogleMaps/OpenGoogleMapsIconButton";
import { TextFieldInput } from "../../../Forms/TextFieldInput";

export const EdcOptionalCoordinatesForm = ({ disabledFields }: MdmFormProps) => {
  const {
    control,
    formState: { disabled: isFormDisabled },
  } = useFormContext<Edc>();

  const { googleMapsModal, openGoogleMapsModal } = useGoogleMapsModal<Edc>(
    "AltLatitude",
    "AltLongitude"
  );

  return (
    <BorderedFormGrid>
      {googleMapsModal}
      <Grid item xs={12}>
        <TextFieldInput
          name="AltLatitude"
          control={control}
          label="Latitude"
          disabledFields={disabledFields}
          InputProps={{
            endAdornment: <OpenGoogleMapsIconButton onClick={openGoogleMapsModal} />,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="AltLongitude"
          control={control}
          label="Longitude"
          disabledFields={disabledFields}
          InputProps={{
            endAdornment: <OpenGoogleMapsIconButton onClick={openGoogleMapsModal} />,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="AltMgLatitude"
          control={control}
          label="M&G Latitude"
          disabledFields={disabledFields}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="AltMgLongitude"
          control={control}
          label="M&G Longitude"
          disabledFields={disabledFields}
        />
      </Grid>
    </BorderedFormGrid>
  );
};
